var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 10.8C12.6628 10.8 13.2 11.3372 13.2 12V18.0011C13.2 18.6638 12.6628 19.2011 12 19.2011C11.3372 19.2011 10.8 18.6638 10.8 18.0011V12C10.8 11.3372 11.3372 10.8 12 10.8ZM12 8.4C12.6628 8.4 13.2 7.86274 13.2 7.2C13.2 6.53726 12.6628 6 12 6C11.3372 6 10.8 6.53726 10.8 7.2C10.8 7.86274 11.3372 8.4 12 8.4Z",
    fill: "#95A4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentInfo);
export default __webpack_public_path__ + "static/media/assessmentInfo.fbfa37c409e90f9b8895559610312811.svg";
export { ForwardRef as ReactComponent };